<form [formGroup]="form">
  <app-sla-selector [form]="form"></app-sla-selector>
  <h3 class="subtitulo">Devedor</h3>
  <div formGroupName="titular">
    <div class="form-row">
      <div class="col-7">
        <mat-form-field appearance="outline" class="inputs">
          <mat-label>Nome</mat-label>
          <input
            matInput
            type="text"
            formControlName="nome"
            placeholder="Nome"
            maxlength="55"
            noSpecialChars
          />
          <mat-hint align="end">{{nome.value?.length || 0}} / 55</mat-hint>
          <mat-error *ngIf="nome.hasError('required')">
            Nome completo é <strong>obrigat&oacute;rio</strong>
          </mat-error>
          <mat-error *ngIf="nome.hasError('valueOnlyNumberError')">
            Nome do devedor não pode conter apenas números
          </mat-error>
          <mat-error *ngIf="nome.hasError('titularesEmpty')">
            Ao menos um devedor deve ser adicionado!
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-3">
        <mat-form-field appearance="outline" class="inputs">
          <mat-label>CPF/CNPJ</mat-label>
          <input
            matInput
            type='text'
            mask="000.000.000-00||00.000.000/0000-00"
            placeholder="CPF/CNPJ"
            formControlName="documento"
          />
          <mat-error *ngIf="documento.hasError('required')">
            CPF/CNPJ é <strong>obrigat&oacute;rio</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="d-flex justify-content-center align-items-center col-auto">
        <button
          mat-button
          class="btn btn-branco"
          type="button"
          [disabled]="disableAddDevedor()"
          (click)="addTitular()"
        >
          Adicionar
        </button>
      </div>
    </div>
  </div>

  <table mat-table class="mat-elevation-z2" [dataSource]="titulares" *ngIf="titulares.length > 0" aria-label="Tabela de Titulares">
    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef> Nome </th>
      <td mat-cell *matCellDef="let titular">
        <ng-container *ngIf="editedTitular !== titular; else editarNome">
          {{ titular.nome }}
        </ng-container>
        <ng-template #editarNome>
          <mat-form-field appearance="outline">
            <input matInput formControlName="nomeEdicao" placeholder="Nome" maxlength="55" noSpecialChars/>
            <mat-hint align="end">{{nomeEdicao.value?.length || 0}} / 55</mat-hint>
            <mat-error *ngIf="nomeEdicao.hasError('required')">
              Nome completo é <strong>obrigat&oacute;rio</strong>
            </mat-error>
            <mat-error *ngIf="nomeEdicao.hasError('valueOnlyNumberError')">
              Nome do devedor não pode conter apenas números
            </mat-error>
          </mat-form-field>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="documento">
      <th mat-header-cell *matHeaderCellDef> Documento </th>
      <td mat-cell *matCellDef="let titular">
        <ng-container *ngIf="editedTitular !== titular; else editarDocumento">
          {{ titular.documento | mask: isPessoaFisica(titular.documento) ? '000.000.000-00' : '00.000.000/0000-00' }}
        </ng-container>
        <ng-template #editarDocumento>
          <mat-form-field appearance="outline">
            <input matInput type='text' mask="000.000.000-00||00.000.000/0000-00"
              formControlName="documentoEdicao" placeholder="CPF/CNPJ"/>
            <mat-error *ngIf="documentoEdicao.hasError('required')">
              CPF/CNPJ é <strong>obrigat&oacute;rio</strong>
            </mat-error>
          </mat-form-field>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef> Ações </th>
      <td mat-cell *matCellDef="let titular">
        <ng-container *ngIf="editedTitular !== titular; else checkIcon">
          <button mat-icon-button [matMenuTriggerFor]="menu" type="button">
            <mat-icon class="table-icon">more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu" xPosition="after">
            <button mat-menu-item
              (click)="removerTitular(titular)"
            >
              <mat-icon class="table-icon">close</mat-icon>
              <span>Excluir</span>
            </button>
            <button mat-menu-item
              (click)="startEdicao(titular)"
            >
              <mat-icon class="table-icon">edit</mat-icon>
              <span>Editar</span>
            </button>
          </mat-menu>
        </ng-container>

        <ng-template #checkIcon>
          <button mat-icon-button type="button"
            (click)="atualizarTitular(titular)"
            [disabled]="disableAtualizarTitular()"
          >
            <mat-icon class="table-icon">check</mat-icon>
          </button>
        </ng-template>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <div class="form-row">
    <div class="info-message">
      <mat-icon class="info-icon" fontIcon="info"></mat-icon>
      <p>
        Se houver mais devedores, adicionar nesse momento!
      </p>
    </div>
  </div>

  <h3 class="subtitulo">Dados para inclusão</h3>
  <div class="form-row">
    <div class="col-6">
      <mat-form-field appearance="outline" class="inputs">
        <mat-label>Valor da Dívida</mat-label>
        <input
          maxlength="16"
          required
          [currencyMask]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
          matInput
          placeholder="Valor da Anotação"
          formControlName="vlrAcao"
          [attr.data-cy]="'input-valor-divida'"
        />
        <mat-error *ngIf="vlrAcao.hasError('required')">
          Valor da dívida é <strong>obrigat&oacute;rio</strong>
        </mat-error>
        <mat-error *ngIf="vlrAcao.hasError('valueZeroError')">
          O Valor não pode ser <strong>0,00</strong>
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-sm-7">

    </div>
    <div class="col-sm-5">
      <app-acao-buttons
        [tipoOrdem]="'ATUALIZACAO_ACAO'"
        (onConfirmar)="atualizarAcao()"
      ></app-acao-buttons>
    </div>
  </div>
</form>
